import React from "react";
import { Card, Alert } from "react-bootstrap";

function ConnectorsOverview() {
  return (
    <div>
      <h2 className="mb-4">Connectors Overview</h2>

      <Alert variant="info">
        Connectors store authentication credentials that runbooks use to connect to external systems and APIs.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>What are Connectors?</h4>
          <p>
            Connectors are secure storage for authentication credentials (usernames, passwords, API keys, tokens, etc.)
            that your runbooks need to access external systems.
          </p>
          <p className="mt-3">
            Instead of embedding credentials directly in runbooks, you create a connector once and reference it
            by name in your workflows. This makes credentials easier to manage and more secure.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Why Use Connectors?</h4>
          <ul>
            <li><strong>Security</strong> - Credentials are stored securely and not visible in workflows</li>
            <li><strong>Reusability</strong> - One connector can be used by multiple runbooks</li>
            <li><strong>Easy Updates</strong> - Change credentials in one place without editing runbooks</li>
            <li><strong>Testing</strong> - Verify credentials work before using them in production</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Your Connectors</h4>
          <ol>
            <li>Click <strong>My Connectors</strong> in the left menu</li>
            <li>You'll see a grid of all configured connectors</li>
            <li>Each connector shows:
              <ul className="mt-2">
                <li>Connector ID/Number</li>
                <li>Description</li>
                <li>System type</li>
                <li>Login endpoint</li>
                <li>Company ID (if applicable)</li>
              </ul>
            </li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Connector Information</h4>
          <p>Each connector contains:</p>
          <ul>
            <li><strong>Description</strong> - What this connector is for</li>
            <li><strong>System</strong> - The external system or API type</li>
            <li><strong>Login Endpoint</strong> - The URL used for authentication</li>
            <li><strong>Company ID</strong> - Organization identifier (if required by the system)</li>
            <li><strong>Credentials</strong> - Username/password or API keys (stored securely)</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Using Connectors in Runbooks</h4>
          <p>
            When designing a workflow that needs to access an external system:
          </p>
          <ol>
            <li>Add a step that requires a connector</li>
            <li>In the step configuration, select which connector to use from the dropdown</li>
            <li>The runbook will use those credentials when executing that step</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Connector Security</h4>
          <p>
            Credentials stored in connectors are encrypted and secure. Only authorized users with the
            appropriate permissions can view or modify connectors.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ConnectorsOverview;
